export default __webpack_public_path__ + "assets/img/teacher.0396e78854f590d3bbef9a57d8ada26b.svg";